<template>
  <IconMdiGoogle />
</template>
